require('slick-carousel');

let carousel = $('.blog-list .posts-carousel');
let posts = $('.blog-list .post-card');

export default {
  fire() {
    carousel.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      variableWidth: true,
      arrows: false,
      mobileFirst: true,
      infinite: false,
      responsive: [
        {
          breakpoint: 991,
          settings: 'unslick',
        },
      ],
    });

    posts.css('cursor', 'pointer').on('click', function () {
      window.location.href = $(this).attr('data-href');
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/components/post-carousel.js